import { motion } from "motion/react";

export const LightningBolts = () => {
  return (
    <>
      {/* Bolt 1 - Large main branch */}
      <motion.svg
        className="absolute top-[-10%] left-[5%] w-[400px] md:w-[600px] h-[800px] md:h-[1000px] pointer-events-none z-0 opacity-80"
        viewBox="0 0 400 800"
        preserveAspectRatio="none"
        animate={{ opacity: [0, 0, 0, 0, 0, 0, 0.8, 0.2, 1, 0, 0, 0, 0] }}
        transition={{ duration: 4.2, repeat: Infinity, ease: "linear" }}
      >
        {/* Main Trunk */}
        <path
          d="M200 0 L190 30 L220 50 L180 100 L210 130 L170 200 L190 230 L150 350 L180 370 L120 500 L140 520 L80 680 L100 700 L50 800"
          fill="none"
          stroke="#c084fc"
          strokeWidth="1.2"
          filter="drop-shadow(0 0 10px rgba(168,85,247,0.9))"
        />
        {/* Branch 1 */}
        <path
          d="M180 100 L140 150 L160 170 L90 280 L110 300 L40 450 L60 470 L0 550"
          fill="none"
          stroke="#d8b4fe"
          strokeWidth="0.6"
          filter="drop-shadow(0 0 8px rgba(168,85,247,0.7))"
        />
        {/* Branch 2 */}
        <path
          d="M150 350 L120 400 L135 410 L80 500"
          fill="none"
          stroke="#d8b4fe"
          strokeWidth="0.4"
          filter="drop-shadow(0 0 5px rgba(168,85,247,0.6))"
        />
        {/* Branch 3 Right */}
        <path
          d="M170 200 L230 250 L210 280 L280 380 L250 420 L320 550"
          fill="none"
          stroke="#d8b4fe"
          strokeWidth="0.5"
          filter="drop-shadow(0 0 6px rgba(168,85,247,0.6))"
        />
      </motion.svg>

      {/* Bolt 2 - Medium right branch */}
      <motion.svg
        className="absolute top-[0%] right-[5%] w-[350px] md:w-[450px] h-[700px] md:h-[900px] pointer-events-none z-0 opacity-70"
        viewBox="0 0 350 700"
        preserveAspectRatio="none"
        animate={{ opacity: [0, 0, 0, 0, 0, 0, 0, 0, 0.9, 0.1, 0.5, 0, 0] }}
        transition={{ duration: 5.8, repeat: Infinity, ease: "linear", delay: 1.5 }}
      >
        <path
          d="M150 0 L160 50 L130 80 L180 150 L150 180 L200 300 L180 330 L250 500 L220 530 L300 700"
          fill="none"
          stroke="#c084fc"
          strokeWidth="0.9"
          filter="drop-shadow(0 0 12px rgba(168,85,247,0.8))"
        />
        {/* Branch */}
        <path
          d="M180 150 L240 220 L220 250 L300 380 L280 410 L350 500"
          fill="none"
          stroke="#d8b4fe"
          strokeWidth="0.5"
          filter="drop-shadow(0 0 6px rgba(168,85,247,0.6))"
        />
      </motion.svg>

      {/* Bolt 3 - Small faint background branch */}
      <motion.svg
        className="absolute top-[20%] left-[30%] w-[250px] md:w-[350px] h-[500px] md:h-[700px] pointer-events-none z-0 opacity-50"
        viewBox="0 0 250 500"
        preserveAspectRatio="none"
        animate={{ opacity: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0.7, 0.2, 1, 0] }}
        transition={{ duration: 6.5, repeat: Infinity, ease: "linear", delay: 2.8 }}
      >
        <path
          d="M100 0 L120 40 L90 80 L130 150 L110 190 L160 300 L140 330 L180 450 L160 470 L200 500"
          fill="none"
          stroke="#c084fc"
          strokeWidth="0.6"
          filter="drop-shadow(0 0 8px rgba(168,85,247,0.8))"
        />
        <path
          d="M90 80 L50 120 L70 140 L20 250 L40 270 L0 350"
          fill="none"
          stroke="#d8b4fe"
          strokeWidth="0.4"
        />
      </motion.svg>
      
      {/* Background ambient flash */}
      <motion.div
        className="absolute inset-0 bg-[#c084fc]/15 mix-blend-screen pointer-events-none z-0"
        animate={{ opacity: [0, 0, 0, 0, 0, 0, 0.3, 0.05, 0.5, 0, 0, 0, 0] }}
        transition={{ duration: 4.2, repeat: Infinity, ease: "linear" }}
      />
    </>
  );
};
